import { useNavigate } from 'react-router-dom';

import { activateVideo, deleteVideo } from 'api/Video';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import Popover from 'components/shared/Popovers/Popover/Popover';

const TableActions = ({ data }) => {
  const navigate = useNavigate();

  const { mutate, isPending } = useCustomMutation({
    mutationFn: () => deleteVideo(navigate, { video_id: data.id }),
    invalidateQueryKey: 'videos'
  });

  const { mutate: activateMutate, isPending: isUpdatePending } = useCustomMutation({
    mutationFn: () => activateVideo(navigate, { video_id: data.id, is_active: true }),
    invalidateQueryKey: 'videos'
  });

  const options = data.is_active
    ? [
        {
          label: 'Deactivate video',
          disabled: isPending,
          icon: 'close-circle-filled',
          onClick: () => {
            mutate();
          }
        }
      ]
    : [
        {
          label: 'Activate video',
          disabled: isUpdatePending,
          icon: 'checkbox-circle-filled',
          onClick: () => {
            activateMutate();
          }
        }
      ];

  return (
    <Popover
      className="flex h-full w-full items-center justify-center"
      position="left"
      isFixed
      icon="context-menu-horizontal"
      isBorder={false}
      options={options}
    />
  );
};

export default TableActions;
